const { origin } = window.location;
const domain = origin;

const blogUrl = `${domain}/blog/`;
const imagesUrl = `${blogUrl}images/`;

export const fetchPosts = async () => {
  try {
    const response = await fetch(`${blogUrl}posts.json`);
    if (!response.ok) {
      throw new Error('Failed to fetch posts');
    }
    const posts = await response.json();
    return posts.map(post => ({
      ...post,
      url: blogUrl + post.url,
      image: imagesUrl + post.image
    }));
  } catch (error) {
    console.error('Error fetching posts:', error);
    return [];
  }
};
